// removed by extract-text-webpack-plugin
module.exports = {"container":"dndTotalHeader__container___2EWm5","containerPrint":"dndTotalHeader__containerPrint___28F-6","totalBox":"dndTotalHeader__totalBox___2dV1_","item":"dndTotalHeader__item___3-4wd print__printHidden___3GLMT","itemPrint":"dndTotalHeader__itemPrint___3SEIn","divider":"dndTotalHeader__divider___30VTr print__printHidden___3GLMT","dividerPrint":"dndTotalHeader__dividerPrint___3BHdi"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/lib/tables/dnd/dndTotalHeader.css
// module id = 1450
// module chunks = 0